export const icons16 = [
  "add",
  "arrow-down",
  "arrow-left",
  "arrow-link",
  "arrow-right",
  "arrow-up",
  "box",
  "calendar",
  "caret-down",
  "caret-left",
  "caret-right",
  "caret-up",
  "cell-type-num",
  "cell-type-subset",
  "cell-type-txt",
  "checkmark",
  "chevron-down",
  "chevron-first",
  "chevron-last",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "clipboard-copied",
  "clipboard",
  "close",
  "copy",
  "data-dimentions",
  "delete-bin",
  "delete-circle",
  "delete-clear",
  "download",
  "drag-dots",
  "duplicate",
  "edit",
  "error",
  "export",
  "filter-on",
  "filter",
  "help-outline",
  "help",
  "info-outline",
  "info",
  "jump-link",
  "link",
  "loading",
  "lock",
  "maximize",
  "minimize",
  "minus",
  "more",
  "open",
  "paper-clip",
  "pause",
  "play",
  "progress",
  "renew",
  "restart",
  "reverse",
  "settings",
  "sort",
  "stop",
  "success",
  "time",
  "tune",
  "warning",
  "x-axis",
  "y-axis",
  "zip",
] as const;
